import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { DeferRenderingModule } from 'app/shared/directives/defer-rendering/defer-rendering.module';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { ButtonModule } from '../../../button/button.module';
import { CheckBoxModule } from '../../../check-box/check-box.module';
import { DropdownModule } from '../../../dropdown/dropdown.module';
import { InputBoxModule } from '../../../input-box/input-box.module';
import { ListModule } from '../../../list/list.module';
import { LoadingPanelModule } from '../../../loading-panel/loading-panel.module';
import { ScrollViewModule } from '../../../scroll-view/scroll-view.module';
import { SelectBoxModule } from '../../../select-box/select-box.module';
import { TabsModule } from '../../../tabs/tabs.module';
import { BufferFormModule } from '../buffer-form/buffer-form.module';
import { HighlightConfigFormModule } from '../highlight-config-form/highlight-config-form.module';
import { ResultsTableViewModule } from './components/results-table-view/results-table-view.module';
import { SearchResultsInternalComponent } from './search-results-internal.component';
import { DateBoxModule } from '@components/date-box/date-box.module';

@NgModule({
  imports: [
    CommonModule,
    InputBoxModule,
    SelectBoxModule,
    CheckBoxModule,
    DropdownModule,
    TabsModule,
    ListModule,
    ScrollViewModule,
    ButtonModule,
    LoadingPanelModule,
    BlockModalDragModule,
    DeferRenderingModule,
    ResultsTableViewModule,
    PipesModule,
    HighlightConfigFormModule,
    BufferFormModule,
    DateBoxModule,
    InputBoxModule,
  ],
  declarations: [SearchResultsInternalComponent],
  exports: [SearchResultsInternalComponent],
})
export class SearchResultsInternalModule {}
